import { SHIPPING_TYPE } from '@monorepo/config';
import { t } from 'i18next';

const EMPTY = '- -';

// proto3 JSON trả int64 dạng chuỗi ("173123"). Không Number() thẳng: Number(null) và Number('') ra 0,
// hiển thị thành "0 ₫"/"0 tháng" thay vì ô trống.
export const toNumber = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const numberValue = Number(value);
  return Number.isFinite(numberValue) ? numberValue : null;
};

// Chép cách hiển thị của web vận hành (apps/fulfillment/…/Order/Detail/components/DeliveryMethod): dòng
// "Phương thức giao hàng" luôn có, rồi thêm dòng riêng theo loại. REST public chưa trả SĐT/bến nhà xe
// và phí giao nội thành nên chưa có các dòng đó.
export const getShippingRows = (shippingType, shippingConfig, shippingTypeName) => {
  // BE không trả chữ thì hiện thẳng enum để lộ ra chỗ thiếu.
  const rows = [
    { label: t('orderTracking.deliveryMethod'), value: shippingTypeName || shippingType || t('orderTracking.no') },
  ];

  switch (shippingType) {
    case SHIPPING_TYPE.BUS:
      rows.push({ label: t('orderTracking.busName'), value: shippingConfig?.busConfig?.busName || EMPTY });
      break;
    case SHIPPING_TYPE.DELIVER_3PARTY:
    case SHIPPING_TYPE.DELIVER_3PARTY_INSTANT:
      // Chỉ tên hãng, không kèm tên dịch vụ ("4H") — như dòng "ĐVVC" bên vận hành.
      rows.push({ label: t('orderTracking.shippingUnit'), value: shippingConfig?.deliver3PartyConfig?.name || EMPTY });
      break;
    default:
      break;
  }

  return rows;
};
